export {default} from './SocialMedia';
